export const BANNO_LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]'])

function hostnameIsLocalhost(hostname: string): boolean {
  return BANNO_LOCAL_HOSTNAMES.has(hostname.toLowerCase())
}

function hostHasDotSuffix(host: string, suffix: string): boolean {
  return host === suffix || host.endsWith(`.${suffix}`)
}

/** Heuristic registrable domain (last two labels); sufficient for typical eTLD+1 hosts. */
function deriveRegistrableDomain(hostname: string): string | undefined {
  const parts = hostname.split('.').filter(Boolean)
  if (parts.length < 2) return undefined
  return parts.slice(-2).join('.')
}

/**
 * Cookie Domain for Banno plugin sessions. Returns undefined for host-only cookies
 * (recommended when the plugin API is served from a single origin).
 */
export function deriveBannoCookieDomain(
  redirectOrigin: string | null | undefined,
  requestHostname: string
): string | undefined {
  const reqHost = typeof requestHostname === 'string' ? requestHostname.trim().toLowerCase() : ''
  if (!reqHost || hostnameIsLocalhost(reqHost)) {
    return undefined
  }

  if (!redirectOrigin) {
    return undefined
  }

  try {
    const parsed = new URL(redirectOrigin)
    const originHost = parsed.hostname.toLowerCase()
    if (hostnameIsLocalhost(originHost)) {
      return undefined
    }
    if (originHost === reqHost) {
      return undefined
    }
    // Shared parent domain when redirect base and request host differ (unusual).
    const registrableDomain = deriveRegistrableDomain(originHost)
    const reqRegistrableDomain = deriveRegistrableDomain(reqHost)
    if (
      registrableDomain &&
      registrableDomain === reqRegistrableDomain &&
      hostHasDotSuffix(originHost, registrableDomain) &&
      hostHasDotSuffix(reqHost, registrableDomain)
    ) {
      return `.${registrableDomain}`
    }
  } catch {
    return undefined
  }

  return undefined
}
